export const navigation = [
    {
        name: 'Home',
        url: '/dashboard',
        icon: 'icon-home'
    },
    {
        title: true,
        name: 'Menu'
    },
    {
        name: 'Unsubscribe files',
        url: '/files/unsubs',
        icon: 'icon-docs'
    },
    {
        name: 'Files',
        url: '/files/nounsubs',
        icon: 'icon-docs'
    },
    {
        name: 'User Source',
        url: '/users/sources',
        icon: 'icon-people'
    },
    {
        name: 'Reporting',
        icon: 'icon-speedometer',
        url: '#',
        children: [
            {
                name: 'Calls',
                url: '/reporting/calls',
                icon: 'icon-call-in'
            },
        ]
    },
    {
        name: 'Settings',
        url: '/settings',
        icon: 'icon-settings'
    }
];



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/_nav.ts